import { icon } from "@fortawesome/fontawesome-svg-core/import.macro"
import PurchaseOrderDetailsContainer from "@legacy/purchase_orders/PurchaseOrderDetailsContainer"

import useHasAccess from "@hooks/useHasAccess"
import useIsDesktop from "@hooks/useIsDesktop"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useToastQueue from "@hooks/useToastQueue"

import { TopBar } from "@organisms"

import { AppFrame } from "@templates"

import { PURCHASE_ORDER_ROUTES } from "@routes/purchase-orders"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

export default function PurchaseOrderDetails() {
    const isDesktop = useIsDesktop()

    const [listRoute] = useSlugExtractor([PURCHASE_ORDER_ROUTES.LIST])
    const { addToastToQueue } = useToastQueue()
    const { hasPermission } = useHasAccess()

    const backDestination = hasPermission("purchase_orders_list_permission", PERMISSION_LEVEL.FULL)
        ? listRoute
        : undefined

    return (
        <AppFrame.Root pageId="PurchaseOrderDetails">
            <TopBar.Root>
                <TopBar.Header>
                    <TopBar.TopBarHeaderStart>
                        <TopBar.PageTitle
                            label="Purchase Orders"
                            icon={icon({ name: "basket-shopping", style: "regular", family: "sharp" })}
                            iconActive={icon({ name: "basket-shopping", style: "solid", family: "sharp" })}
                            destination={backDestination}
                            iconOnly={!isDesktop}
                        />
                        <TopBar.VerticalDivider />
                        <TopBar.PageSubtitle label="Purchase Order Details" backDestination={backDestination} />
                    </TopBar.TopBarHeaderStart>
                </TopBar.Header>
            </TopBar.Root>
            <AppFrame.PageContent>
                <PurchaseOrderDetailsContainer addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
